import React, { useState, useEffect } from 'react';

export interface StringIntervalProps {
    strings: string[];
    delay?: number;
}

export const StringInterval: React.FC<StringIntervalProps> = ({ strings, delay = 2000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (strings.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % strings.length);
        }, delay);

        return () => clearInterval(interval);
    }, [strings, delay]);

    if (strings.length === 0) return null;

    return <span>{strings[currentIndex]}</span>;
};